import { z } from 'zod';

import { zodContractSchema } from '../validations';

export { zodContractSchema } from '../validations';

export const zodContractsBulkResponseSchema = z.object({
  data: z.array(zodContractSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});
